import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=2913a9e6&scoped=true&lang=pug"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=2913a9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913a9e6",
  null
  
)

export default component.exports